import { CIcon } from '~/icons/types'

export const ciBan: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 1.5a10.43 10.43 0 0 0-7.467 3.117A10.5 10.5 0 0 0 19.172 19.67l.007-.007A10.5 10.5 0 0 0 12 1.5Zm0 18A7.5 7.5 0 0 1 5.7 7.926l10.2 10.482A7.471 7.471 0 0 1 12 19.5Zm6.1-3.131L7.8 5.783a7.5 7.5 0 0 1 10.3 10.586Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'ban',
  type: 'solid'
}
